/** @format */

import { BreakPointNew } from '@shared/data-access/enums';

export interface BreakpointMediaQuery {
  breakpoint: BreakPointNew;
  query: string;
}
